import { Controller } from "@hotwired/stimulus";

const COPY_END_EVENT = "clipboard:copy:end";

export default class extends Controller {
  static targets = ["container"];

  copy() {
    const copyText = this.containerTarget.textContent;
    const previouslyFocused = document.activeElement;
    const textArea = document.createElement("textarea");
    textArea.textContent = copyText;
    this.element.append(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand("copy");
    textArea.remove();
    previouslyFocused?.focus();
    this.dispatchEvent(COPY_END_EVENT, copyText);
  }

  dispatchEvent(eventName, content) {
    const detail = { element: this.containerTarget, content };
    const event = new CustomEvent(eventName, { detail });
    this.element.dispatchEvent(event);
  }
}
